
import { mapState, mapActions } from "vuex";
import smsOtp from "~/assets/images/smsOtp.svg";
import emailOtp from "~/assets/images/emailOtp.svg";
import backButtonFullHeight from "../common/back-button-full-height.vue";
export default {
  components: { backButtonFullHeight },
  name: "SignupOtpVerification",
  data() {
    return {
      smsOtp,
      emailOtp,
      otp: "",
      formError: "",
      loading: false,
      valid: true,
      otpTimer: 0,
      resendOtpTimer: 0,
      otpIntervalID: "",
      otpResendIntervalID: "",
      otpRules: [
        (v) => !!v || "OTP is required",
        (v) => /\d{6}/.test(v) || "Sorry! Invalid OTP"
      ]
    };
  },
  props: {
    signupData: {},
    isEmailOtp: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.startOtpTimer();
    if (this.signupData.password) {
      this.resendOtp();
    }
  },
  methods: {
    ...mapActions("auth", [
      "verifySignupMobileOtp",
      "verifySignupEmailOtp",
      "requestSignupMobileOtp",
      "requestSignupEmailOtp",
      "login"
    ]),
    startOtpTimer() {
      clearInterval(this.otpIntervalID);
      this.otpTimer = 15 * 60;
      this.otpIntervalID = setInterval(this.decreaseOtpTimer, 1000);
    },
    decreaseOtpTimer() {
      this.otpTimer--;
      if (this.otpTimer == 0) {
        clearInterval(this.otpResendIntervalID);
      }
    },
    startOtpResendTimer() {
      this.startOtpTimer();
      clearInterval(this.otpResendIntervalID);
      this.resendOtpTimer = 2 * 60;
      this.otpResendIntervalID = setInterval(this.decreaseOtpResendTimer, 1000);
    },
    decreaseOtpResendTimer() {
      this.resendOtpTimer--;
      if (this.resendOtpTimer == 0) {
        clearInterval(this.otpResendIntervalID);
      }
    },
    validateForm() {
      this.valid = this.$refs.formOtp.validate();
    },
    submitOtp() {
      this.validateForm();
      const $this = this;
      if (this.valid) {
        this.loading = true;
        const payload = {
          otp_code: this.otp.toString()
          // platform: "web"
        };
        if (!this.isEmailOtp) {
          payload.mobile_number = this.signupData.mobile;
        } else {
          payload.email = this.signupData.email;
        }
        const verify = this.isEmailOtp
          ? this.verifySignupEmailOtp
          : this.verifySignupMobileOtp;
        verify(payload)
          .then((response) => {
            if (response.data.status === "success") {
              this.otp = "";
              let bodyFormData = new FormData();
              bodyFormData.append("platform", "web");
              if (this.isEmailOtp) {
                bodyFormData.append("email", this.signupData.email);
              } else {
                bodyFormData.append(
                  "mobile_number",
                  this.signupData.countrycode + this.signupData.mobile
                );
              }

              bodyFormData.append("password", this.signupData.password);

              this.login(bodyFormData)
                .then((res) => {
                  if (!res.data.business?.id) {
                    this.$router.push({
                      name: "restaurant-create-restaurant"
                    });
                  } else {
                    this.$router.push({
                      name: "food-menu"
                    });
                  }
                })
                .catch((err) => {
                  this.$router.push({
                    name: "login-signup"
                  });
                });
            } else {
              this.$nuxt.$emit("show-error-toast", response);
            }
          })
          .catch((errr) => {
            this.$nuxt.$emit("show-error-toast", errr);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    resendOtp() {
      let request, payload;
      if (this.isEmailOtp) {
        request = this.requestSignupEmailOtp;
        payload = {
          email: this.signupData.email,
          service: "email_verification",
          platform: "web"
        };
      } else {
        request = this.requestSignupMobileOtp;
        payload = {
          mobile_number: this.signupData.mobile,
          service: "mobile_verification",
          platform: "web"
        };
      }
      request(payload)
        .then((response) => {
          this.startOtpResendTimer();
          this.$nuxt.$emit("show-toast", {
            text: response.data.message,
            color: "success darken-2",
            icon: "done",
            flat: true
          });
        })
        .catch((errr) => {
          this.$nuxt.$emit("show-error-toast", errr);
        });
    }
  }
};
